import React from 'react';
import { Ticket } from 'lucide-react';

const EVENT_URL = 'https://entradium.com/es/events/vivo-tinta-by-don-t-stop-en-sala-badulaque-madrid-2026/sessions/23-05-2026-19-00-bar-badulaque-don-t-stop';

/**
 * "COMPRAR ENTRADAS 23.05 - 19 HRS" button restyled to fit the page's
 * cream/lavender/gold palette. Same text content as the provided design,
 * integrated with the site's typography and gentle animations.
 */
export default function EventButton() {
  return (
    <a
      href={EVENT_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="event-btn group inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold tracking-[0.12em] text-[#3a2410] shadow-[0_10px_24px_-10px_rgba(150,95,20,0.55)] transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_30px_-10px_rgba(150,95,20,0.65)]"
    >
      <span className="event-btn-shine" aria-hidden="true" />
      <Ticket className="w-4 h-4 relative" strokeWidth={2} />
      <span className="relative text-[0.78rem] sm:text-[0.85rem] whitespace-nowrap">
        COMPRAR ENTRADAS 23.05 · 19 HRS
      </span>
    </a>
  );
}
